<template>
    <div id="waitingPayment">
        <nav-bar>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
            <div slot="title">支付订单</div>
        </nav-bar>
        <div class="wait-order-info">
            <van-image :src="require('@/assets/image/icon/waiting-pay.png')"></van-image>
            <div class="wait-order-info-text">
                <p>订单提交成功</p>
                <p>请在{{overtime.minute}}分 {{overtime.second}}秒内完成支付</p>
                <p>支付金额 <span>￥{{frompay.amount}}</span></p>
            </div>
        </div>
<!--        <van-cell-group>-->
<!--            <van-field type="password" v-model = "frompay.password" label="支付密码" placeholder="请输入支付密码"  />-->
<!--        </van-cell-group>-->
        <div class="pay-password">
            <div v-html="rawHtml"></div>
        </div>
            <van-button round color="linear-gradient(to right, #ff6034, #ee0a24)"  @click="submitPay" :disabled="disabled" block>立即付款</van-button>
        <div style="width: 100%; height: 135px; background: #ffffff"></div>
    </div>
</template>


<script>
    import { Icon, Image, Button, Field, CellGroup, Toast,Popup, PasswordInput, NumberKeyboard } from 'vant';
    import NavBar from "@/components/common/navbar/NavBar";
    import {submitPayment, verifyOrder, inquirePayPwd, orderSetting, isInsertOrderPay} from "@/network/order/order.js";
    import {onBridgeReady} from "../../config/wxConfig"
    export default {
        name: "WaitingPayment",
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Image.name]: Image,
            [Button.name]: Button,
            [Field.name]: Field,
            [CellGroup.name]: CellGroup,
            [Toast.name]: Toast,
            [Popup.name]: Popup,
            [PasswordInput.name]: PasswordInput,
            [NumberKeyboard.name]: NumberKeyboard,
        },
        data() {
            return{
                frompay:{
                    password : "",
                    orderSn: "",
                    amount: "",
                    payType: "",
                    productName: "",
                    isWechatBrowser: 2
                },
                show: false,
                img:"",
                path: this.$route.path,
                overtime:{
                    time:3600,
                    minute:"",
                    second:"",
                    date:"",
                    timer:"",
                },
                rawHtml:"",
                num1:"",
                timer1:"",
                disabled: false,
            }
        },
        methods: {
            goBack() {
                this.$router.push({path: '/order/personalOrders'})
            },
            submitPay(){
                this.disabled = true;
                Toast.loading("正在支付请稍后");
                setTimeout(() => {
                    Toast.clear()
                    //单点支付接口
                    isInsertOrderPay(this.frompay).then(res => {
                        console.log(res)
                    })
                    submitPayment(this.frompay).then(resp => {
                        //验证成功之后 跳转到支付宝页面
                        if(resp.code=="200"){
                            //支付宝支付
                            if (this.frompay.payType == 1){
                                // 添加之前先删除一下，如果单页面，页面不刷新，添加进去的内容会一直保留在页面中，二次调用form表单会出错
                                let divForm = document.getElementsByTagName('divform')
                                if (divForm.length) {
                                    document.body.removeChild(divForm[0])
                                }
                                const div = document.createElement('divform');
                                div.innerHTML = resp.data.from; // data就是接口返回的form 表单字符串
                                document.body.appendChild(div);
                                document.forms[0].setAttribute('target', '_blank') // 新开窗口跳转
                                document.forms[0].submit();
                                // var as = $(resp.data).find('.weui-form-preview__ft>.weui-form-preview__btn');
                                // var url = as.attr("href");
                                // window.location.href = resp.data;
                            }else if(this.frompay.payType == 2){ //微信支付
                                //调用微信 jsapi支付
                                if (this.frompay.isWechatBrowser==4){
                                    //调用微信jsapi支付(只限制于微信浏览器)
                                    if (typeof WeixinJSBridge == "undefined") {
                                        if (document.addEventListener) {
                                            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                        } else if (document.attachEvent) {
                                            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                                            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                        }
                                    } else {
                                        onBridgeReady(resp.data);
                                        // chooseWXPay(resp.data.wxConfigModule, resp.data.prepay_id, resp.data.paySign);
                                    }
                                }else {
                                    window.location.href =  resp.data.url;
                                }
                            }
                        }else{
                            // console.log(resp);
                            // if (resp.code == 500 && resp.message == "支付密码为空"){
                            //     Toast('请设置支付密码！')
                            //     this.$router.push({path: '/mine/setUserPay',query: {lastSource: 'noSubmitOrder'}});
                            //     return false
                            // }
                            Toast('支付失败!')
                        }
                    })
                }, 1000)


            },
            disabledfun(){
                if(this.overtime.timer == ""){
                    this.overtime.timer = setInterval(this.addnum, 1000);
                }
            },
            isWeiXin() {
                //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
                var ua = window.navigator.userAgent.toLowerCase();
                //通过正则表达式匹配ua中是否含有MicroMessenger字符串
                if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                    return 4;
                } else{
                    return 2;
                }
            },
            addnum(){//设置计时器
                if (this.overtime.time == 0){
                    clearInterval(this.timer);
                    return true;
                }//end
                this.overtime.time--;
                let date = new Date(this.overtime.time*1000);
                this.overtime.minute = date.getMinutes();
                this.overtime.second = date.getSeconds();
            },
            disabledfun1(){
                this.timer1 = setInterval(this.addnum1, 1000);
            },
            addnum1(){//设置计时器
                if (this.num1 == 0){
                    this.num1 = 60;
                    this.disabled = false;
                    clearInterval(this.timer1);
                    return true;
                }
                this.num1--;
            }

        },
        created(){
            //获取订单设置，
            orderSetting(1).then(res =>{
                if (res.code == 200){
                    this.overtime.time = res.data.normalOrderOvertime*60;
                }
            })

            //调用计时器
            if (this.overtime.time != 0){
                this.disabledfun();
            }

            //判断微信是否是微信登录
            if (this.isWeiXin()==4){
                this.frompay.isWechatBrowser = 4;
            }
            //验证表单是否是当前用户的
            let data = {
                orderSn: this.$route.query.id,
                //传入状态0为 待付款状态
                status:"0"
            };

            //验证订单是否是自己的订单
            verifyOrder(data).then(res => {
                //获取订单的信息 以及付款信息
                if (res){
                    this.frompay.amount = res.data.payAmount;
                    this.frompay.paySn = res.data.orderSn;
                    //设置支付方式
                    this.frompay.payType = res.data.payType;
                }
                //验证是自己订单之后 验证是否有支付密码
               // return  inquirePayPwd()
            },err => {
                //如果订单请求错误则
            })
            //核验用户是否有支付密码 （主要针对刚注册的用户）

        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/login.css";

    #waitingPayment{
        background: #ffffff;
    }

    .van-nav-bar {
        box-shadow: 0px 1px 3px 0px rgba(0,0,0,.5);
        background-color: #ffffff;
    }

    .wait-order-info {
        height: 267px;
        background-color: #fff;
        margin-top: 46px;
        text-align: center;
    }
    .wait-order-info .van-image {
        top: 35px;
    }
    .wait-order-info-text {
        margin-top: 56px;
    }
    .wait-order-info-text p {
        font-size: 18px;
        color: #999999;
        margin-block-start: 0.1em;
        margin-block-end: 0.1em;
    }
    .wait-order-info-text span {
        color: red;
    }
    .van-button {
        margin: 54px auto;
        width: 96%;
    }

    .van-cell-group {
        margin-top: 20px;
    }
</style>
